export default __webpack_public_path__ + "static/media/Voldemort's Wand - Img - Wip 1_05.8cb5e24a.jpg";